module.exports = __webpack_public_path__ + "static/media/icon_add.a63c6b65.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/icon_add.svg
// module id = 430
// module chunks = 0